import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import ServicePersonList from './ScheduleConsultation/ServicePersonList';
class ChangeServicePersonPopup extends Component {
  constructor() {
    super();
    this.update_service_person_info = this.update_service_person.bind(this);
    this.state = {
      service_person_list:'',
      all_table_row:[],
      update_button: <button className="btn btn-primary w-100 py-3" onClick={this.update_service_person_info} type="button">Update</button>,
    };
  }

componentDidMount(){
  this.get_service_person();
  var service_person_id = this.props.service_person_id;
  setTimeout(function(){
    $('#service_person_id').val(service_person_id);
  }.bind(this,service_person_id),900)
}
get_service_person(){
  let cutThis = this;
  var web_token = $('#web_token').val();
   var body = new FormData();
   body.append('web_token',web_token);
   body.append('function','get_service_person_list');
   var url      = '';
   if(window.location.host ==="localhost:3000"){
     url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
   }else{
     url = "/php/admin_free_consultation_url.php";
   }
   axios({
        method: 'POST',
        url: url,
        data: body
    })
    .then(function (res) {
      var data = res.data;
      var service_person_list = data['msg'];
      cutThis.setState({service_person_list});
    })
    .catch(function (error) {
        console.log(error);
    });
}

add_service_person(){
  var all_table_row = this.state.all_table_row;
  var list = this.state.service_person_list;
  var loaction_id = all_table_row.length;
  all_table_row.push(<ServicePersonList service_person_list={list} delete_service_person={this.delete_service_person_row.bind(this)}/>);
  this.setState({all_table_row});
}
delete_service_person_row(index){
  console.log(index);
  var all_table_row = this.state.all_table_row;
  all_table_row.splice(index, 1);
  this.setState({all_table_row});
}

update_service_person(){
  let cutThis               = this;
  var update_button         = <button className="btn btn-primary w-100 py-3" type="button">Updating...</button>;
  cutThis.setState({update_button});
  $('label').removeClass('color_red');

  var service_person_id       = window.isNullAndUndef($('#service_person_id').val());
  var web_token               = window.isNullAndUndef($('#web_token').val());
  var old_service_person_id   = cutThis.props.service_person_id;
  var consulting_id           = cutThis.props.id;

  if(service_person_id && web_token){
    var body = new FormData();
    body.append('web_token',web_token);
    body.append('service_person_id',service_person_id);
    body.append('old_service_person_id',old_service_person_id);
    body.append('consulting_id',consulting_id);
    body.append('function','update_schedule_consultation_service_person');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
    }else{
      url = "/php/admin_free_consultation_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
       var data = res.data;
       console.log(data);
     })
     .catch(function (error) {
         console.log(error);
     });
  }else{
    window.change_lable_color('service_person_id');
    update_button     = <button className="btn btn-primary w-100 py-3" onClick={this.update_service_person_info} type="button">Update</button>;
    cutThis.setState({update_button});
  }
  setTimeout(function () {$('#error_msg').text('').addClass('hide').removeClass('color_red');}, 20000);

}

  render() {
    return (
      <div className="modal fade" id="myModal" role="dialog">
        <div className="modal-dialog popup_view_width">
          <div className="modal-content">
            <div className="modal-header">
            <h4 className="modal-title" id="page_titlte">Change Service Person</h4>
              <button type="button" className="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
            </div>
            <div className="modal-body">


            <div className="form_popup_scroll">
            <div className="col-md-12">
                <div className="wow fadeInUp" data-wow-delay="0.5s">
                    <form action="" method="post">
                        <div className="row g-3">


                            <div className="col-md-12">
                            <table class="table">
                            <thead>
                            <tr>
                            <th scope="col">Service Person</th>
                            <th scope="col">Roal</th>
                            <th scope="col"><a  onClick={this.add_service_person.bind(this)}><i class="fas fa-user-plus pointer"></i></a></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.all_table_row}
                            </tbody>
                            </table>
                            </div>

                            <div className="col-md-12">
                              <div className="col-md-8 p-0">
                                <p className="hide" id="error_msg"></p>
                              </div>
                              <div className="col-md-2 p-0 float_r">
                                  {this.state.update_button}
                              </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            </div>


            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChangeServicePersonPopup;
